import { CustomHeading } from 'components';
import { Images } from 'constants';
import React, { useEffect } from 'react'

const TopWinner = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const top_winner_list = [
        { image: Images.M1, name: 'mixxxu1', amount: '3,247,000', bgColor: '#4A0000' },
        { image: Images.M2, name: 'z4xxx98', amount: '1,362,500', bgColor: '#064955' },
        { image: Images.M3, name: 'rexxx88', amount: '1,255,000', bgColor: '#3357FF' },
        { image: Images.M4, name: 'jaxxx33', amount: '450,039', bgColor: '#FF33A1' },
        { image: Images.M5, name: 'z9xxx88', amount: '414,570', bgColor: '#F0E68C' },
        { image: Images.M6, name: 'z3xxx61', amount: '410,339', bgColor: '#FFBD33' },
        { image: Images.M7, name: 'rexxx88', amount: '384,000', bgColor: '#8E44AD' },
        { image: Images.M8, name: 'chxxx01', amount: '347,575', bgColor: '#2ECC71' },
        { image: Images.M9, name: 'roxxx57', amount: '317,544', bgColor: '#D35400' },
        { image: Images.M10, name: 'gbxxx88', amount: '191,400', bgColor: '#2980B9' },
        { image: Images.M11, name: 'poxxx55', amount: '150,951', bgColor: '#16A085' },
        { image: Images.M12, name: 'z2xxx20', amount: '150,001', bgColor: '#C0392B' },
        { image: Images.M13, name: 'raxxxra', amount: '100,662', bgColor: '#7F8C8D' },
        { image: Images.M14, name: 'prxxx51', amount: '85,943', bgColor: '#F39C12' },
        { image: Images.M15, name: 'sdxxx34', amount: '80,924', bgColor: '#9B59B6' },
        { image: Images.M16, name: 'soxxx77', amount: '80,578', bgColor: '#1ABC9C' },
        { image: Images.M17, name: 'baxxx01', amount: '79,301', bgColor: '#34495E' },
        { image: Images.M18, name: 'anxxx34', amount: '75,586', bgColor: '#E67E22' },
        { image: Images.M19, name: 'dexxxar', amount: '74,715', bgColor: '#BDC3C7' },
        { image: Images.M20, name: 'shxxx22', amount: '71,500', bgColor: '#E74C3C' },
    ];



    return (
        <div className=" flex justify-center items-center top-winners">
            <div>
                <CustomHeading
                    svg={false}
                    text="Top Winners"
                    down_icon={true}
                    redirect={false}
                    type={1}
                />

                <div className="grid grid-cols-2 sm:grid-cols-2 gap-2 mt-2 mx-1">
                    {top_winner_list.map((item, key) => (
                        <div className=''>
                            <div key={key} className={`top-winners-slider max-w-[190px]`} style={{ background: item.bgColor }}>
                                <div className='w-full grid justify-center grid-cols-1'>
                                    <div className='flex justify-center'>
                                        <img src={item.image} alt={item.name} />
                                    </div>
                                    <div className='winner-details flex justify-start items-center p-1' style={{ background: item.bgColor }}>
                                        <div className='w-full px-2'>
                                            <div className='flex justify-between items-center'>
                                                <span className='key'>Player:</span>
                                                <span className="value">{item.name}...</span>
                                            </div>
                                            <div className='flex justify-between items-center'>
                                                <span className='key'>Win Amt.:</span>
                                                <span className="value">{item.amount}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default TopWinner